// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"740fd479","232":"938a24d3","237":"49571cbe","526":"3df8f05d","528":"f88a8408","787":"0db01ea0","872":"4a192a24"}[chunkId] + ".chunk.js";
};